import { defineComponent as _defineComponent } from 'vue'
import NavUser from '@/components/layout/NavUser.vue';
import BaseButton from "@/components-UI/BaseButton.vue";
import { computed } from "vue";
import { useTasksStore } from "@/store_v3/MyTasksStore";
import { storeToRefs } from "pinia";
import SvgTasksMarker from "@/assets/icons/tasks-marker.svg";
import SvgTasks from "@/assets/icons/tasks.svg";
import { useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavAppBar',
  emits: ['toggle-menu'],
  setup(__props, { emit }) {



const toggleMenu = () => {
    emit('toggle-menu');
};
const router = useRouter();
const { tasksCount } = storeToRefs(useTasksStore());
const getIcon = computed(() => tasksCount.value > 0 ? SvgTasksMarker : SvgTasks);
const goToTasks = () => {
    router.push({ name: 'tasks' });
};


return { __sfc: true,emit, toggleMenu, router, tasksCount, getIcon, goToTasks, NavUser, BaseButton }
}

})